import React from 'react';
import { View, Text, ScrollView, RefreshControl, StyleSheet } from 'react-native';
import { Header } from '../../components/Header';
import { StatusBadge } from '../../components/StatusBadge';
import { useGetMeetingsQuery } from '../../store/api';
import { useTheme } from '../../theme/ThemeContext';
import { MeetingStatus } from '../../types';
import { COLORS, getThemeStyles, globalStyles } from '../../theme/designSystem';

export const ApprovedMeetingsScreen = () => {
  const { data: meetings = [], isLoading, refetch } = useGetMeetingsQuery({ status: MeetingStatus.CONFIRMED });
  const { isDark } = useTheme();
  const theme = getThemeStyles(isDark);

  return (
    <View style={[globalStyles.container, { backgroundColor: theme.bg }]}>
      <Header title="Approved Meetings" subtitle="Confirmed visitor schedule & notification records" />

      <ScrollView
        style={{ flex: 1 }}
        contentContainerStyle={{ paddingHorizontal: 20, paddingBottom: 24 }}
        refreshControl={<RefreshControl refreshing={isLoading} onRefresh={refetch} />}
      >
        {meetings.length === 0 ? (
          <View style={[globalStyles.card, { backgroundColor: theme.cardBg, borderColor: theme.border, alignItems: 'center', marginVertical: 20 }]}>
            <Text style={{ fontSize: 32, marginBottom: 8 }}>📋</Text>
            <Text style={[styles.emptyTitle, { color: theme.textPrimary }]}>
              No confirmed meetings found
            </Text>
          </View>
        ) : (
          meetings.map((meeting) => (
            <View
              key={meeting.id}
              style={[styles.meetingCard, { backgroundColor: theme.cardBg, borderColor: theme.border }]}
            >
              <View style={{ flex: 1, marginRight: 10 }}>
                <Text style={[styles.visitorName, { color: theme.textPrimary }]}>
                  {meeting.visitorName}
                </Text>
                {meeting.visitorCompany && (
                  <Text style={[styles.companyName, { color: theme.textSecondary }]}>
                    {meeting.visitorCompany}
                  </Text>
                )}
                <Text style={[styles.slotText, { color: theme.textSecondary }]}>
                  📅 {meeting.meetingDate} at <Text style={{ color: COLORS.success, fontWeight: '800' }}>{meeting.meetingTime}</Text>
                </Text>
                {meeting.adminRemarks && (
                  <Text style={styles.remarksText}>
                    Remarks: {meeting.adminRemarks}
                  </Text>
                )}
              </View>

              <StatusBadge status={meeting.status} />
            </View>
          ))
        )}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  emptyTitle: {
    fontSize: 14,
    fontWeight: '700',
  },
  meetingCard: {
    padding: 16,
    borderRadius: 16,
    borderWidth: 1,
    marginBottom: 12,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  visitorName: {
    fontSize: 15,
    fontWeight: '800',
  },
  companyName: {
    fontSize: 11,
    marginBottom: 4,
  },
  slotText: {
    fontSize: 11,
  },
  remarksText: {
    fontSize: 11,
    color: COLORS.success,
    fontStyle: 'italic',
    marginTop: 4,
  },
});
